export type EnvironmentType =
  | "development"
  | "production"
  | "preproduction"
  | "staging";

export const environment: EnvironmentType =
  (import.meta.env.VITE_ENVIRONMENT as EnvironmentType) || "development";
export const baseUrl: string =
  import.meta.env.VITE_API_BASE_URL || "https://dev.hsmhusdcode.jigaysa.com";

export const config = {
  // Core Configuration
  baseUrl,
  environment,

  // Debug and Development Configuration
  enableDebug: import.meta.env.VITE_ENABLE_DEBUG === "true",
  enableConsoleLogs: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === "true",

  // Development Features (disabled in production)
  enableRoleSelector: import.meta.env.VITE_ENABLE_ROLE_SELECTOR === "true",
  enableDummyData: import.meta.env.VITE_ENABLE_DUMMY_DATA === "true",

  // Security Configuration
  enableNetworkProtection:
    import.meta.env.VITE_ENABLE_NETWORK_PROTECTION === "true",
  enforceHttps: import.meta.env.VITE_ENFORCE_HTTPS === "true",

  // Session Management
  sessionTimeout: parseInt(import.meta.env.VITE_SESSION_TIMEOUT || "1800000"), // 30 minutes default
  tokenRefreshThreshold: parseInt(
    import.meta.env.VITE_TOKEN_REFRESH_THRESHOLD || "300000"
  ), // 5 minutes default

  // File Upload Configuration
  maxFileSize: parseInt(import.meta.env.VITE_MAX_FILE_SIZE || "10485760"), // 10MB default
  allowedFileTypes: (
    import.meta.env.VITE_ALLOWED_FILE_TYPES ||
    "application/pdf,image/jpeg,image/png"
  ).split(","),

  // Admin Configuration (for development and staging)
  superAdminEmail: import.meta.env.VITE_SUPER_ADMIN_EMAIL || "",
  superAdminPassword: import.meta.env.VITE_SUPER_ADMIN_PASSWORD || "12345",
  testEmailPrefix: import.meta.env.VITE_TEST_EMAIL_PREFIX || "ec",
  testUserPassword: import.meta.env.VITE_TEST_USER_PASSWORD || "12345",

  // Environment Helper Methods
  isProduction: () => environment === "production",
  isDevelopment: () => environment === "development",
  isPreproduction: () => environment === "preproduction",
  isStaging: () => environment === "staging",
};
